import { classToPlain, plainToClass } from '../../../../node_modules/.pnpm/class-transformer@0.5.1/node_modules/class-transformer/esm5/index.js';
import lib from '../../../../node_modules/.pnpm/qs@6.12.1/node_modules/qs/lib/index.js';

function removeUndefinedProps(obj) {
  var o = obj;
  var keys = Object.keys(o);
  for (var i = 0; i < keys.length; i += 1) {
    var key = keys[i];
    if (o[key] === undefined) {
      delete o[key];
    }
  }
  return o;
}
function removeTrailingSlashes(url) {
  return url.replace(/\/+$/, ''); // Removes one or more trailing slashes from URL
}
function removeDuplicateForwardSlashes(url) {
  return url.replace(/([^:]\/)\/+/g, '$1'); // remove duplicate forward slashes
}
function encodeObjectasUrlParam(object) {
  // Attention can handle object depth of 5 max! You don't store objects in URLs are you?
  return lib.stringify(classToPlain(object), {
    encode: false,
    skipNulls: true // plainToClass in decoder can handle this
  });
}
function decodeObjectFromUrlParam(t, str) {
  return plainToClass(t, lib.parse(str, {
    allowDots: true,
    decoder: function decoder(s, _d, charset) {
      var strWithoutPlus = s.replace(/\+/g, ' ');
      if (charset === 'iso-8859-1') {
        return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
      }
      if (/^(\d+|\d*\.\d+)$/.test(s)) {
        return parseFloat(s);
      }
      var keywords = {
        "true": true,
        "false": false,
        "null": null,
        undefined: undefined
      };
      if (s in keywords) {
        return keywords[s];
      }
      // utf-8
      try {
        return decodeURIComponent(strWithoutPlus);
      } catch (e) {
        return strWithoutPlus;
      }
    }
  }));
}
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function decodeAnyAsUrlParam(str) {
  return JSON.parse(decodeURIComponent(str));
}

export { decodeAnyAsUrlParam, decodeObjectFromUrlParam, encodeObjectasUrlParam, removeDuplicateForwardSlashes, removeTrailingSlashes, removeUndefinedProps };
//# sourceMappingURL=url.js.map
